module.exports = __webpack_public_path__ + "static/media/ShopOnBudget1.77e68187.png";